<template>
  <div id="left-menu">
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <v-list-item class="ma-2 d-md-none d-lg-none d-xl-none">
          <v-toolbar-title style="width: 200px" class="ml-0 pl-1">
            <img :src="logo" width="100px" alt="CMS" />
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click.stop="drawer = !drawer" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-list-item>
        <div v-for="item in filteredItems" :key="item.text">
          <v-list-item link :to="item.link" :class="item.activePath === $route.meta.activePath
            ? 'v-list-item--active'
            : ''
            ">
            <v-list-item-action style="background-color:none">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data: () => ({
    items: [
      { icon: "mdi-home", text: "Home", link: "/", activePath: "/" },
      {
        icon: "mdi-newspaper",
        text: "Administration",
        link: "/activities/monthly",
        activePath: "activities",
      },
      {
        icon: "mdi-cash-multiple",
        text: "Contributions",
        link: "/activities/contributions",
        activePath: "contributions",
      },
      // {
      //   icon: "mdi-newspaper",
      //   text: "Trust Sheet",
      //   link: "/trust-sheet",
      //   activePath: "trust-sheet",
      // },
      {
        icon: "mdi-lightbulb-on",
        text: "Service Projects",
        link: "/projects",
        activePath: "projects",
      },
      {
        icon: "mdi-account-multiple-plus",
        text: "Club Members",
        link: "/members",
        activePath: "members",
      },
      {
        icon: "mdi-file-tree",
        text: "Clubs",
        link: "/clubs",
        activePath: "clubs",
      },
      {
        icon: "mdi-account-box",
        text: "My Profile",
        link: "/profile",
        activePath: "profile",
      },
      {
        icon: "mdi-chart-line",
        text: "Reports",
        link: "/reports",
        activePath: "reports",
        showRole: "DISTRICT_GLOBAL_ACTION_TEAM_COORDINATOR",
      },
    ],
    logo: require("@/assets/logo.png"),
  }),

  computed: {
    role() {
      return localStorage.getItem("role");
    },
    filteredItems() {
      return this.items.filter((item) => {
        if (item.show === false) return false;
        if (item.showRole && this.role !== item.showRole) return false;
        return true;
      });
    },
    drawer: {
      get() {
        return this.$store.state.auth.drawer;
      },
      set(value) {
        this.$store.commit("auth/setDrawer", value);
      },
    },
  },

  watch: {
    drawer(value) {
      this.toggleNav(value);
    },
  },

  methods: {
    toggleNav: function (value) {
      this.$store.dispatch("auth/changeDrawer", value);
    },
  },
};
</script>

<style>
.v-list-item--active {
  background: rgba(102, 125, 256, 1);
  color: #fff;
}

.v-list .v-list-item--active .v-icon {
  color: #fff;
}

.v-list-item--active .v-list-item__title {
  color: #fff;
}

.v-navigation-drawer__content {
  padding: 15px;
}

.v-navigation-drawer__content .v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: auto;
  border-radius: 50px;
}

.v-navigation-drawer__content .v-list-item--link:before {
  border-radius: 50px;
  background-color: white;
}

.v-list-item--active .v-list-item__action i:before {
  color: #fff;
}
</style>
